import {createAction} from '@reduxjs/toolkit';

import type {PostWithTeamId} from '../types/extended';

export const receivedThreadsFromPosts = createAction<PostWithTeamId[]>('threads/actions/receivedThreadsFromPosts');
